__turbopack_context__.v({
  "itemsSelector": "index-module__rQQqTq__itemsSelector",
  "popup": "index-module__rQQqTq__popup",
});
